<template>
  <div>
    <v-autocomplete
      hide-details
      :value="value"
      clearable
      :items="customerList"
      dense
      flat
      filled
      placeholder="Select Customer"
      item-color="cyan"
      color="cyan"
      solo
      item-text="display_name"
      item-value="id"
      :loading="isLoading"
      :style="customStyle"
      :menu-props="{
        contentClass: isLoading ? 'autocomplete-dropdown-menu is-loading' : '',
      }"
      v-bind="$attrs"
      @change="selectCustomer"
      @click:clear="$emit('click:clear')"
      @keyup.enter="doSearch"
      :search-input.sync="searchInput"
      :filter="filterCustomers"
    >
      <template v-slot:no-data>
        <v-list-item>
          <div
            v-if="isLoading"
            class="w-100 d-flex align-center justify-center py-2"
          >
            <v-progress-circular indeterminate color="cyan" />
          </div>
          <v-list-item-title v-else v-html="'No Customer(s) Found.'" />
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar>
          <v-img
            :lazy-src="$defaultProfileImage"
            :src="item.profile_logo"
            aspect-ratio="1"
            class="margin-auto"
            transition="fade-transition"
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16"
            >{{ item.display_name }}</v-list-item-title
          >
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16"
            >{{ item.company_name }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action
          v-if="item.default_person"
          class="align-self-center"
        >
          <v-list-item-subtitle
            class="text-lowercase pb-2 font-weight-500 font-size-14"
          >
            {{ item.default_person.primary_email }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="text-lowercase font-weight-500 font-size-14"
          >
            {{ item.default_person.primary_phone }}
          </v-list-item-subtitle>
        </v-list-item-action>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import { SET_FILTER_CUSTOMER_LIST } from "@/core/services/store/customer.module";
export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  name: "customer-dropdown",
  data() {
    return {
      isLoading: false,
      customerList: [],
      timeout: null,
      searchInput: "",
      timeoutLimit: 1000,
    };
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    customStyle: {
      type: String,
      default: null,
    },
  },
  watch: {
    searchInput() {
      this.doTypingSearch();
    },
    value: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.getCustomers();
        }
      },
    },
  },
  methods: {
    doTypingSearch() {
      this.isLoading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.doSearch();
      }, this.timeoutLimit);
    },
    filterCustomers(item, queryText) {
      const itemText = `${item?.display_name ?? ""} ${
        item?.company_name ?? ""
      } ${item?.default_person?.display_name ?? ""} ${
        item?.single_property?.barcode ?? ""
      } ${item?.single_property?.street_1 ?? ""} ${
        item?.single_property?.street_2 ?? ""
      } ${item?.single_property?.zip_code ?? ""} ${
        item?.single_billing?.unit_no ?? ""
      } ${item?.single_billing?.street_1 ?? ""} ${
        item?.single_billing?.street_2 ?? ""
      } ${item?.single_billing?.zip_code ?? ""}`;
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    doSearch() {
      const param = this.searchInput || "";
      if (param?.length < 3) {
        this.isLoading = false;
        return;
      }
      const selectedCustomer = this.customerList.find(
        (row) => row.id === this.value
      );
      if (selectedCustomer?.id && selectedCustomer.display_name === param) {
        this.isLoading = false;
        return;
      }
      this.getCustomers(param);
    },
    selectCustomer(value) {
      this.searchInput = "";
      this.$nextTick(() => {
        this.$emit("input", value);
        this.$emit("change", value);
        const valObj = this.customerList.find((row) => row.id == value);
        this.$emit("change:object", valObj);
      });
    },
    getCustomers(search = "") {
      if (this.customerList?.length && !search && !this.value) {
        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "customer-list",
          data: { search, value: this.value },
        })
        .then(({ data }) => {
          this.customerList = data;
          this.$store.commit(SET_FILTER_CUSTOMER_LIST, this.customerList);
        })
        .catch((error) => {
          this.$emit("error", error.message || "Failed to load customers");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (!this.value || !this.customerList?.length) {
      this.getCustomers();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>
